import { gql } from "@apollo/client";

export const SAVE_AUTORIZACION_PRECIO = gql`
    mutation SaveAutorizacionPrecio(
    $idEvaluacion: Int!,
    $precioControl: Decimal!,
    $precioNuevo: Decimal!,
    $idAutorizador: Int!
){
    saveAutorizacionPrecio(
        input : {
            idEvaluacion: $idEvaluacion,
            precioControl: $precioControl,
            precioNuevo: $precioNuevo,
            idAutorizador: $idAutorizador
        }            
    ) 
}
`;